import React, { createContext, useContext, useState, ReactNode } from 'react';
import {
  LaunchedBy,
  TwoWayService,
} from '../components/relay-messenger-axios-service/relay-messenger-axios-service';

interface LaunchedByContextType {
  launchedByList: LaunchedBy[];
  fetchLaunchedByList: (clientId: string) => Promise<void>;
  isLaunchedByError: boolean;
}

interface ProviderProps {
  children: ReactNode;
}

const defaultState: LaunchedByContextType = {
  launchedByList: [],
  fetchLaunchedByList: async () => {},
  isLaunchedByError: false,
};
const LaunchedByContext = createContext<LaunchedByContextType>(defaultState);

export const useLaunchedBy = () => useContext(LaunchedByContext);

export const LaunchedByProvider = ({ children }: ProviderProps) => {
  const [launchedByList, setLaunchedByList] = useState<LaunchedBy[]>([]);
  const [isLaunchedByError, setIsLaunchedByError] = useState(false);

  const fetchLaunchedByList = async (clientId: string) => {
    if (clientId) {
      try {
        const launchedByList = await TwoWayService.getLaunchedBy(clientId);
        if (launchedByList && launchedByList.length > 0) {
          setLaunchedByList(launchedByList);
        }
      } catch (error) {
        setIsLaunchedByError(true);
      }
    }
  };

  return (
    <LaunchedByContext.Provider
      value={{
        launchedByList,
        isLaunchedByError,
        fetchLaunchedByList,
      }}
    >
      {children}
    </LaunchedByContext.Provider>
  );
};
